import { Avatar, Typography } from "@mui/material";
import moment from "moment";
import { useTranslation } from "react-i18next";

import styles from "./Author.module.scss";

const Author = ({
  author = {},
  publishedDate = "",
  customStyle = "",
  showInCard = false,
}) => {
  const { name, image } = author;

  const cardStyle = {
    base: styles["cardStyle__base"],
    avatar: styles["cardStyle__avatar"],
    names: styles["cardStyle__names"],
    date: styles["cardStyle__date"],
  };

  const appliedStyle = showInCard ? cardStyle : customStyle;

  const {
    i18n: { language },
  } = useTranslation();

  return (
    <div className={`${styles.authorSection} ${appliedStyle.base}`}>
      <Avatar
        alt={author?.name?.en}
        src={image ? image : author?.avatar}
        className={`${styles.avatar} ${appliedStyle.avatar}`}
      />
      <div className={styles.detailContainer}>
        <Typography
          variant="subtitle2"
          className={`${styles.authorNames} ${appliedStyle.names}`}
        >
          {name?.[language]}
        </Typography>
        {publishedDate && (
          <Typography
            variant="caption"
            className={`${styles.publishDate} ${appliedStyle.date}`}
            color="text.secondary"
          >
            {moment(publishedDate).format("MMMM DD, YYYY")}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default Author;
